/**
 * Mensagem de erro de ferramenta pronta para a telemetria OPERACIONAL.
 *
 * As mensagens de erro citam o que o modelo procurou — `Texto não encontrado:
 * "<trecho>"`, `Âncora «<título>» não encontrada` —, e esse trecho costuma ser
 * texto copiado do documento. O modelo precisa dele (é assim que corrige a
 * busca); o log operacional não pode tê-lo (DPO.md, CLAUDE.md). Aqui sai o que
 * estiver entre aspas, e fica o tipo do erro, que é o que interessa a quem opera.
 */
const TRECHOS_CITADOS = [
    /"[^"]*"/g,
    /“[^”]*”/g,
    /«[^»]*»/g,
    /'[^']*'/g,
];
/** Teto do que vai para o `message` do evento. */
export const MAX_LOGGED_ERROR_CHARS = 200;
export function redactToolError(message) {
    let out = String(message !== null && message !== void 0 ? message : '');
    for (const re of TRECHOS_CITADOS)
        out = out.replace(re, '«…»');
    out = out.replace(/\s+/g, ' ').trim();
    return out.length > MAX_LOGGED_ERROR_CHARS ? `${out.slice(0, MAX_LOGGED_ERROR_CHARS)}…` : out;
}
